import { api, baseUrl } from "../../api";

export const getAllDashboardApi = async() =>{
    const  result = await api.get(`${baseUrl}/admin/dashboard/count`);
    return result.data;
}